/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Score_LockedInputs */



/**
* | output |
* | --- |
* | "Table score is locked by judge" |
*
* @param {Err_Tournament_Score_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_score_locked = /** @type {((inputs?: Err_Tournament_Score_LockedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Score_LockedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le score de la table est verrouillé par l'arbitre")
	if (locale === "es") return /** @type {LocalizedString} */ ("La puntuación de la mesa está bloqueada por el juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A pontuação da mesa está bloqueada pelo juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il punteggio del tavolo è bloccato dal giudice")
	return /** @type {LocalizedString} */ ("Table score is locked by judge")
});